<template>
  <a-form :form="form" @submit="getValues">
    <a-row :gutter="16">
      <a-col v-if="notSchoolUsage" :span="24">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['1_1'].q }}</label>
          <a-radio-group
            v-decorator="[
              `survey-1_1`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-1_1`"
          >
            <a-radio-button v-for="id in Object.keys(questions['1_1'].a)" :key="id" :value="id">
              {{ questions['1_1'].a[id] }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="16" v-if="doLiveEvents">
      <a-col :span="24">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['1_2'].q }}</label>
          <a-radio-group
            v-decorator="[
              `survey-1_2`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-1_2`"
          >
            <a-radio-button v-for="id in Object.keys(questions['1_2'].a)" :key="id" :value="id">
              {{ questions['1_2'].a[id] }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="16">
      <a-col :span="24">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['2'].q }}</label>
          <a-radio-group
            v-decorator="[
              `survey-2`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-2`"
          >
            <a-radio-button v-for="id in Object.keys(questions['2'].a)" :key="id" :value="id">
              {{ questions['2'].a[id] }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="16">
      <a-col :span="12">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['3'].q }}</label>
          <a-radio-group
            v-decorator="[
              `survey-3`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-3`"
          >
            <a-radio-button v-for="id in Object.keys(questions['3'].a)" :key="id" :value="id">
              {{ questions['2'].a[id] }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="16" class="px-4 py-4 mb-2 rounded bg-gray-50" v-if="usedByOthers">
      <a-col :span="24">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['3_1'].q }}</label>
          <a-radio-group
            v-decorator="[
              `survey-3_1`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-3_1`"
          >
            <a-radio-button v-for="id in Object.keys(questions['3_1'].a)" :key="id" :value="id">
              {{ questions['3_1'].a[id] }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>

      <a-col :span="24">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['3_2'].q }}</label>
          <a-radio-group
            v-decorator="[
              `survey-3_2`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-3_2`"
          >
            <a-radio-button v-for="id in Object.keys(questions['3_2'].a)" :key="id" :value="id">
              {{ questions['3_2'].a[id] }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="16">
      <a-col :span="24">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['4'].q }}</label>
          <a-radio-group
            v-decorator="[
              `survey-4`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-4`"
          >
            <a-radio-button v-for="id in Object.keys(questions['4'].a)" :key="id" :value="id">
              {{ questions['4'].a[id] }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="16" v-if="alreadyCoveredByInsurance" class="px-4 py-4 mb-2 rounded bg-gray-50">
      <!-- con quale assicurazione? -->
      <a-col :span="12">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['4_1'].q }}</label>
          <a-input
            v-decorator="[
              `survey-4_1`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-4_1`"
            formErrors
            placeholder="nome compagnia"
          />
        </a-form-item>
      </a-col>
      <!-- quando scadra la polizza? -->
      <a-col :span="12">
        <a-form-item :colon="false">
          <label class="mb-6 font-bold" slot="label">{{ questions['4_2'].q }}</label>
          <a-date-picker
            :locale="locale"
            format="DD/MM/YYYY"
            placeholder="Scegli data"
            v-decorator="[
              `survey-4_2`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="
              val =>
                handleSurveyChange({
                  target: { name: `survey-4_2`, value: val.toString() }
                })
            "
            :disabledDate="disabledDatePast"
          />
        </a-form-item>
      </a-col>
    </a-row>

    <!-- lo è stato in passato? -->
    <a-row :gutter="16" v-if="!alreadyCoveredByInsurance">
      <a-col :span="12">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['4_3'].q }}</label>
          <a-radio-group
            v-decorator="[
              `survey-4_3`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-4_3`"
          >
            <a-radio-button v-for="id in Object.keys(questions['4_3'].a)" :key="id" :value="id">
              {{ questions['4_3'].a[id] }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="16" v-if="wasCoveredByInsurance" class="px-4 py-4 mb-2 rounded bg-gray-50">
      <!-- con quale assicurazione -->
      <a-col :span="12">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['4_3_1'].q }}</label>
          <a-input
            v-decorator="[
              `survey-4_3_1`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-4_3_1`"
            formErrors
            placeholder="Oney"
          />
        </a-form-item>
      </a-col>

      <!-- quando è scaduta la polizza -->
      <a-col :span="12">
        <a-form-item :colon="false">
          <label class="mb-6 font-bold" slot="label">{{ questions['4_3_2'].q }}</label>
          <a-date-picker
            :locale="locale"
            format="DD/MM/YYYY"
            placeholder="Scegli data"
            v-decorator="[
              `survey-4_3_2`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="
              val =>
                handleSurveyChange({
                  target: {
                    name: `survey-4_3_2`,
                    value: val.toString()
                  }
                })
            "
            :disabledDate="disabledDateFuture"
          />
        </a-form-item>
      </a-col>

      <!-- perchè non è stata rinnovata la polizza? -->
      <a-col :span="12">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['4_3_3'].q }}</label>
          <a-radio-group
            v-decorator="[
              `survey-4_3_3`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-4_3_3`"
          >
            <a-radio-button v-for="id in Object.keys(questions['4_3_3'].a)" :key="id" :value="id">
              {{ questions['4_3_3'].a[id] }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>

      <!-- se l'utente ha scelto "altro", deve specificare -->
      <a-col :span="12" v-if="survey['4_3_3'] == '1'">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">Specifica le motivazioni</label>
          <a-input
            v-decorator="[
              `survey-4_3_3_other`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-4_3_3_other`"
            formErrors
            placeholder="Non ero soddisfatto del servizio clienti"
          />
        </a-form-item>
      </a-col>
    </a-row>

    <!-- Lo strumento ha subito sinistri negli ultimi 5 anni? -->
    <a-row :gutter="16">
      <a-col :span="24">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">{{ questions['5'].q }}</label>
          <a-radio-group
            v-decorator="[
              `survey-5`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="handleSurveyChange"
            :name="`survey-5`"
          >
            <a-radio-button v-for="id in Object.keys(questions['5'].a)" :key="id" :value="id">
              {{ questions['5'].a[id] }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
    </a-row>

    <!-- se ha subito sinistri, vanno specificati -->
    <a-row
      :gutter="8"
      v-if="hadIncidents"
      v-for="(i, index) in incidents"
      :key="index"
      class="px-4 py-4 mb-2 rounded bg-gray-50"
    >
      <a-col :span="24">
        <h2 class="mb-4 text-lg font-semibold">Descrivi l'incidente</h2>
      </a-col>

      <a-col :span="12">
        <a-form-item :colon="false">
          <label class="mb-1 font-bold" slot="label">
            {{ $t('questions.incidentwhen') }}
          </label>
          <a-date-picker
            :locale="locale"
            format="DD/MM/YYYY"
            :showTime="false"
            placeholder="Scegli data"
            v-decorator="[
              `survey-5_1_when_${index}`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="
              val =>
                handleIncidentChange(index, {
                  key: 'when',
                  value: val,
                  nameFull: `survey-5_1_`,
                  name: 'survey-5_1_when'
                })
            "
            :disabledDate="disabledDateFuture"
          />
        </a-form-item>
      </a-col>

      <a-col :span="12">
        <a-form-item :colon="false">
          <label class="mb-1 font-bold" slot="label">
            {{ $t('questions.incidentwhat') }}
          </label>
          <a-select
            v-decorator="[
              `survey-5_1_what_${index}`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            @change="
              val =>
                handleIncidentChange(index, {
                  key: 'what',
                  value: val,
                  nameFull: `survey-5_1_`,
                  name: 'survey-5_1_what'
                })
            "
          >
            <a-select-option value="steal">{{ $t('questions.steal') }}</a-select-option>
            <a-select-option value="fire">{{ $t('questions.fire') }}</a-select-option>
            <a-select-option value="accident">
              {{ $t('questions.accident') }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>

      <a-col :span="12">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">Valore del danno</label>
          <CurrencyInput
            currency="EUR"
            v-model="incidents[index].value"
            :class="['price-input']"
            inputmode="decimal"
            :valueRange="{ min: 0 }"
            :allowNegative="false"
          />
        </a-form-item>
      </a-col>

      <a-col :span="12" class="pt-12 pl-8">
        <a-button v-if="incidents.length > 1" class="btn-small" @click="removeIncident(index)">
          Rimuovi
        </a-button>
      </a-col>
    </a-row>

    <a-row v-if="hadIncidents">
      <a-col>
        <a-button class="btn-small" @click="addIncident">
          Aggiungi incidente
        </a-button>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import questions from '@/questions.js';
const dayjs = require('dayjs');
const moment = require('moment');
import locale from 'ant-design-vue/es/date-picker/locale/it_IT';

const incidentTemplate = {
  when: '',
  what: '',
  value: 0
};

export default {
  name: 'survey-form',

  props: {
    item: Object,
    survey: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      form: this.$form.createForm(this, { name: 'survey' }),
      submitting: false,
      questions,
      moment,
      incidents: [],
      locale
    };
  },

  computed: {
    notSchoolUsage() {
      return this.survey['1'] !== '3';
    },

    doLiveEvents() {
      return this.survey['1_1'] && this.survey['1_1'] !== '0';
    },

    usedByOthers() {
      return this.survey['3'] === '0';
    },

    alreadyCoveredByInsurance() {
      return this.survey['4'] == '0';
    },

    wasCoveredByInsurance() {
      return !this.alreadyCoveredByInsurance && this.survey['4_3'] === '0';
    },

    hadIncidents() {
      return this.survey['5'] == '0';
    }
  },

  methods: {
    handleSurveyChange(e) {
      const questionId = e.target.name.replace('survey-', '');
      let val = e.target.value;

      console.log(questionId, val);

      if (questionId == 5 && val == 0) {
        this.incidents = [{ ...incidentTemplate }];
      }

      // reset incidents in the case the answer is "no" (1)
      if (questionId == 5 && val == 1) {
        this.incidents = [];
      }

      console.log('debug survey change', e.target.value, questionId);

      this.$emit('change', questionId, val);
    },

    notificateError() {
      this.$notification.error({
        message: 'Ci sono errori nei dati forniti. Controlla e riprova',
        duration: 5
      });
    },

    getValues() {
      return new Promise((resolve, reject) => {
        this.form.validateFieldsAndScroll(
          { scroll: { offsetTop: 30, alignWithTop: true } },
          async (err, values) => {
            if (err) {
              console.log('Form is invalid: ', values, err);
              reject(err);
            }

            // handle properly survey's fields
            let toSend = {};

            for (let field in values) {
              if (field.includes('survey')) {
                let [, questionId] = field.split('-');
                toSend[questionId] = values[field];
              }
            }

            resolve({ ...toSend, incidents: this.incidents });
          }
        );
      });
    },

    disabledDatePast(current) {
      // Can not select days before today and today
      return current && current < dayjs().startOf('day');
    },

    disabledDateFuture(current) {
      // Can not select days after today and today
      return current && current > dayjs().endOf('day');
    },

    removeIncident(index) {
      this.incidents.splice(index, 1);

      this.$nextTick(() => {
        this.incidents.forEach((incident, i) => {
          this.form.setFieldsValue({
            [`${incident.fieldName}what_${i}`]: incident.what,
            [`${incident.fieldName}when_${i}`]: incident.when
          });
        });
      });
    },

    addIncident() {
      this.incidents.push({ ...incidentTemplate });
    },

    handleIncidentChange(index, data) {
      console.log(index, data);
      this.incidents[index][data.key] = data.value;
      this.incidents[index].fieldName = data.nameFull;
    }
  }
};
</script>

<style lang="scss">
.ant-checkbox .ant-checkbox-inner {
  height: 1.5rem;
  width: 1.5rem;
}
.ant-checkbox-inner::after {
  top: 40%;
  left: 15%;
  width: 10px;
  height: 18px;
}
.ant-form-item-control {
  line-height: 1.6rem;
}
</style>
